import React from "react";
import "./GamingStudent.css";

const GamingStudent = () => {
  return (
    <div className="gaming-scene">
      <div className="student-container">
        <div className="student"></div>
        <div className="headphones"></div>
      </div>

      <div className="gaming-pc">
        <div className="pc-screen">
          <div className="coding-text">Welcome</div>
        </div>
      </div>

      <div className="music-wave">
        <div className="wave"></div>
      </div>
    </div>
  );
};

export default GamingStudent;

